import { useTranslation } from 'react-i18next'

import { SearchNode, SupportedLanguage } from '../../__generated__/api'
import api from '../services/api'

import { useApi } from './useApi'
import { useOHC } from './useOHC'

export const useNode = (
  nodeId: string | undefined,
  makeRequest = true
): { node: SearchNode | null; pending: boolean } => {
  const { i18n } = useTranslation()
  const { isOHCSide, ohcAllowedStatus } = useOHC()

  const {
    data: node,
    pending: nodePending,
    error,
  } = useApi(
    api.v1.searchNode,
    {
      nodeId: nodeId,
      isOhc: isOHCSide,
      lang: i18n.language as SupportedLanguage,
    },
    [],
    Boolean(makeRequest) &&
      Boolean(nodeId) &&
      ((isOHCSide && ohcAllowedStatus !== null && ohcAllowedStatus !== 'disallowed') || !isOHCSide)
  )
  return { node: node.length === 0 || error ? null : node[0], pending: nodePending }
}
